import React, { useState } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { NotificationManager } from "react-notifications";

import { sendSubscribe } from "../../store/actions";
import { required, email } from "../../constants/formValidators";
import { FormField } from "../../sharedComponents/formField";

const SubscribeNewsletter = ({ handleSubmit, sendSubscribe, setShow }) => {
    const [submitting, setSubmitting] = useState(false);
    const submitSubscribe = (values) => {
        const successHandler = (event) => {
            NotificationManager.success("Successfully subscribed to our newsletter.", "", 5000);
            setShow(false);
        }
        sendSubscribe(values, successHandler);
        setSubmitting(true);
    }

    return <div className="subscribe-newsletter-wrap">
        <div className="subscribe-newsletter-btn">
            <form className="pt-3" onSubmit={handleSubmit(submitSubscribe)}>
                <h4 className="pt-3">Newsletter Subscribe</h4>
                <div className="row">
                    <Field
                        label="Email address"
                        name="email"
                        formGroupClass="no-label col-12"
                        type="text"
                        component={FormField}
                        validate={[required, email]}
                    />
                </div>
                <div className="text-right w-100">
                    <button className="btn btn-default" type="button" onClick={() => setShow(false)}>Cancel</button>
                    <button className="btn btn-primary-dark" type="submit" disabled={submitting}>Submit</button>
                </div>
            </form>
        </div>
    </div>
}

export default connect(null, { sendSubscribe })(
    reduxForm({
        form: "SubscribeNewsletterForm"
    })(SubscribeNewsletter)
);
